
// This is an auto generated file - do not edit!
// Swagger path: /api/User/me/recents

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseApiService } from '../base-api.service';
import {
    RecentRecord
} from '@wdx/clmi/clmi-swagger-gen';

@Injectable({ providedIn: 'root' })
export class UserMeRecentsApiService extends BaseApiService {
    
    get(options = {}): Observable<RecentRecord[]> {
        return this._get<RecentRecord[]>(
            `/User/me/recents`,
            options
        );
    }
}
